module.exports = __webpack_public_path__ + "img/marmelaedchen-mittellandkanal_xs.aefecd6a.jpg";